import React from "react";
import assets from "../../assets";
import "./style.sass";
import useHandler from "./handler";
import { useSingleton } from "../../hooks/use-singleton";

export const KnowledgeBase = () => {
  const { user } = useSingleton();
  const {
    selectedChapter,
    setSelectedChapter,
    file,
    isDragging,
    chapters,
    isUploading,
    isCallingKB,
    uploadSuccess,
    fileInputRef,
    handleDragOver,
    handleDragLeave,
    handleDrop,
    handleFileChange,
    handleUpload,
    handleKnowledgeBaseAction,
    bankingSubjects,
    selectedBankingSubject,
    setSelectedBankingSubject,
    upscSubjects,
    selectedUpscSubject,
    setSelectedUpscSubject,
    upscUnits,
    selectedUpscUnit,
    setSelectedUpscUnit,
    tnpscUnits,
    selectedTnpscUnit,
    setSelectedTnpscUnit,
    isSubjectDropdownOpen,
    setIsSubjectDropdownOpen,
    isUnitDropdownOpen,
    setIsUnitDropdownOpen,
    fetchUpscUnits,
    isDropdownOpen,
    setIsDropdownOpen,
    setChapters,
    dropdownRef,
    subjectDropdownRef,
    unitDropdownRef,
    customChapter,
    setCustomChapter,
    selectedExam,
    setSelectedExam,
    exams,
    isExamDropdownOpen,
    setIsExamDropdownOpen,
    examDropdownRef,
  } = useHandler();

  const exam = user?.data?.course || user?.data?.exam;
  const type = exam?.toLowerCase();
const isUpsc = user?.data?.clas === "UPSC" && user?.data?.course === "UPSC";
  return (
    <>
      {isCallingKB && (
        <div className="kb_processing_overlay">
          <div className="kb_processing_box">
            <div className="kb_spinner">
              <span></span>
              <span></span>
              <span></span>
            </div>
            <p className="kb_processing_text">
              Processing your content and updating the knowledge base. Please
              stay on this page.
            </p>
          </div>
        </div>
      )}
      <div className="knowledge_base_container">
        <div className="kb_header">
          <h1>Knowledge Base</h1>
          <p>Manage and organize learning materials.</p>
        </div>

        <div className="upload_card">
          <div className="card_header">
            <h2>Upload Content</h2>
            <p>
              Upload study materials, notes, and resources to help students
              learn better.
            </p>
          </div>

          {/* Banking Subject */}
          {bankingSubjects && type === "banking" && (
            <div className="form_group">
              <label>Subject</label>
              <div
                className="custom_dropdown_container"
                ref={subjectDropdownRef}
              >
                <div
                  className={`dropdown_header ${isSubjectDropdownOpen ? "open" : ""}`}
                  onClick={() =>
                    setIsSubjectDropdownOpen(!isSubjectDropdownOpen)
                  }
                >
                  <span
                    className={!selectedBankingSubject ? "placeholder" : ""}
                  >
                    {selectedBankingSubject || "Select Subject"}
                  </span>
                  <img
                    src={assets.ic_chevron_down}
                    className={`chevron ${isSubjectDropdownOpen ? "rotate" : ""}`}
                  />
                </div>
                {isSubjectDropdownOpen && (
                  <div className="dropdown_list_container">
                    <div className="dropdown_list">
                      {bankingSubjects.length === 0 ? (
                        <div className="dropdown_item">No subjects found</div>
                      ) : (
                        bankingSubjects?.map((s, i) => (
                          <div
                            key={i}
                            className="dropdown_item"
                            onClick={() => {
                              setSelectedBankingSubject(s);
                              setIsSubjectDropdownOpen(false);
                            }}
                          >
                            {s}
                          </div>
                        ))
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* UPSC Subject & Unit */}
          {upscSubjects && type === "upsc" && (
            <>
              <div className="form_group">
                <label>Subject</label>
                <div
                  className="custom_dropdown_container"
                  ref={subjectDropdownRef}
                >
                  <div
                    className={`dropdown_header ${isSubjectDropdownOpen ? "open" : ""}`}
                    onClick={() =>
                      setIsSubjectDropdownOpen(!isSubjectDropdownOpen)
                    }
                  >
                    <span className={!selectedUpscSubject ? "placeholder" : ""}>
                      {selectedUpscSubject || "Select Subject"}
                    </span>
                    <img
                      src={assets.ic_chevron_down}
                      className={`chevron ${isSubjectDropdownOpen ? "rotate" : ""}`}
                    />
                  </div>
                  {isSubjectDropdownOpen && (
                    <div className="dropdown_list_container">
                      <div className="dropdown_list">
                        {upscSubjects.length === 0 ? (
                          <div className="dropdown_item">No subjects found</div>
                        ) : (
                          upscSubjects.map((s, i) => (
                            <div
                              key={i}
                              className="dropdown_item"
                              onClick={() => {
                                setSelectedUpscSubject(s);
                                setSelectedUpscUnit(""); // Clear unit
                                setChapters([]); // Clear chapters
                                setSelectedChapter(""); // Clear selected chapter
                                setIsSubjectDropdownOpen(false);
                                fetchUpscUnits(s);
                              }}
                            >
                              {s}
                            </div>
                          ))
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className="form_group">
                <label>Unit</label>
                <div
                  className="custom_dropdown_container"
                  ref={unitDropdownRef}
                >
                  <div
                    className={`dropdown_header ${isUnitDropdownOpen ? "open" : ""}`}
                    onClick={() => setIsUnitDropdownOpen(!isUnitDropdownOpen)}
                  >
                    <span className={!selectedUpscUnit ? "placeholder" : ""}>
                      {selectedUpscUnit || "Select Unit"}
                    </span>
                    <img
                      src={assets.ic_chevron_down}
                      className={`chevron ${isUnitDropdownOpen ? "rotate" : ""}`}
                    />
                  </div>
                  {isUnitDropdownOpen && (
                    <div className="dropdown_list_container">
                      <div className="dropdown_list">
                        {upscUnits.length === 0 ? (
                          <div className="dropdown_item">No subjects found</div>
                        ) : (
                          upscUnits.map((u, i) => (
                            <div
                              key={i}
                              className="dropdown_item"
                              onClick={() => {
                                setSelectedUpscUnit(u);
                                setChapters([]); // Clear chapters
                                setSelectedChapter(""); // Clear selected chapter
                                setIsUnitDropdownOpen(false);
                              }}
                            >
                              {u}
                            </div>
                          ))
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </>
          )}

          {/* TNPSC Unit */}
          {tnpscUnits && type === "tnpsc" && (
            <div className="form_group">
              <label>Unit</label>
              <div className="custom_dropdown_container" ref={unitDropdownRef}>
                <div
                  className={`dropdown_header ${isUnitDropdownOpen ? "open" : ""}`}
                  onClick={() => setIsUnitDropdownOpen(!isUnitDropdownOpen)}
                >
                  <span className={!selectedTnpscUnit ? "placeholder" : ""}>
                    {selectedTnpscUnit || "Select Unit"}
                  </span>
                  <img
                    src={assets.ic_chevron_down}
                    className={`chevron ${isUnitDropdownOpen ? "rotate" : ""}`}
                  />
                </div>
                {isUnitDropdownOpen && (
                  <div className="dropdown_list_container">
                    <div className="dropdown_list">
                      {tnpscUnits.length === 0 ? (
                        <div className="dropdown_item">No units found</div>
                      ) : (
                        tnpscUnits.map((u, i) => (
                          <div
                            key={i}
                            className="dropdown_item"
                            onClick={() => {
                              setSelectedTnpscUnit(u);
                              setIsUnitDropdownOpen(false);
                            }}
                          >
                            {u}
                          </div>
                        ))
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
          <div className="form_group">
            <label>Exam</label>

            <div className="custom_dropdown_container" ref={examDropdownRef}>
              <div
                className={`dropdown_header ${
                  isExamDropdownOpen ? "open" : ""
                }`}
                onClick={() => setIsExamDropdownOpen(!isExamDropdownOpen)}
              >
                <span className={!selectedExam ? "placeholder" : ""}>
                  {selectedExam || "Select Exam"}
                </span>

                <img
                  src={assets.ic_chevron_down}
                  alt="chevron"
                  className={`chevron ${isExamDropdownOpen ? "rotate" : ""}`}
                />
              </div>

              {isExamDropdownOpen && (
                <div className="dropdown_list_container">
                  <div className="dropdown_list">
                    {exams.length === 0 ? (
                      <div className="dropdown_item">No exams found</div>
                    ) : (
                      exams.map((exam, index) => (
                        <div
                          key={index}
                          className={`dropdown_item ${
                            selectedExam === exam ? "selected" : ""
                          }`}
                          onClick={() => {
                            setSelectedExam(exam);
                            setIsExamDropdownOpen(false);

                            // clear previous chapter
                            setSelectedChapter("");
                            setChapters([]);
                          }}
                        >
                          {exam}
                        </div>
                      ))
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="form_group">
            <label>{isUpsc ? "Lesson" : "Chapter"}</label>
            <div className="custom_dropdown_container" ref={dropdownRef}>
              <div
                className={`dropdown_header ${isDropdownOpen ? "open" : ""}`}
                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
              >
                {/* <span className={!selectedChapter ? "placeholder" : ""}>
                  {selectedChapter || "Select Chapter"}
                </span> */}
                {/* <span className={!selectedChapter ? "placeholder" : ""}>
                  {!selectedChapter && user?.data?.clas==="UPSC" && user.data?.course==="UPSC"
                    ? "Select Chapter"
                    : selectedChapter.toLowerCase().includes("all chapters")
                      ? "Others"
                      : selectedChapter}
                </span> */}
                <span className={!selectedChapter ? "placeholder" : ""}>
                  {!selectedChapter
                    ? isUpsc
                      ? "Select Lesson"
                      : "Select Chapter"
                    : selectedChapter.toLowerCase().includes("all chapters")
                      ? "Others"
                      : selectedChapter}
                </span>
                <img
                  src={assets.ic_chevron_down}
                  alt="chevron"
                  className={`chevron ${isDropdownOpen ? "rotate" : ""}`}
                />
              </div>

              {isDropdownOpen && (
                <div
                  className="dropdown_list_container"
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="dropdown_list">
                    {!selectedExam ? (
                      <div className="dropdown_item">Please select exam</div>
                    ) : chapters.length === 0 ? (
                      <div className="dropdown_item">No chapters found</div>
                    ) : (
                      chapters.map((ch, index) => (
                        <div
                          key={index}
                          className={`dropdown_item ${
                            selectedChapter === ch ? "selected" : ""
                          }`}
                          onClick={() => {
                            setSelectedChapter(ch);
                            setIsDropdownOpen(false);
                          }}
                        >
                          {ch.toLowerCase().includes("all chapters") ||
                          ch.toLowerCase().includes("all lessons")
                            ? "Others"
                            : ch}
                        </div>
                      ))
                    )}
                  </div>
                </div>
              )}
              {/* {selectedChapter === "All Chapters"&& ( */}
              {selectedChapter?.toLowerCase().includes("all") && (
                <div className="form_group">
                  {/* <label>Chapter Name</label> */}
                  <input
                    type="text"
                    className="custom_input"
                    placeholder={
                      isUpsc ? "Enter Lesson Name" : "Enter Chapter Name"
                    }
                    value={customChapter}
                    onChange={(e) => setCustomChapter(e.target.value)}
                  />
                </div>
              )}
            </div>
          </div>

          <div className="upload_section">
            <label>PDF Upload</label>
            <div
              className={`drop_zone ${isDragging ? "dragging" : ""} ${
                file ? "has_file" : ""
              }`}
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
              onDrop={handleDrop}
              onClick={() => fileInputRef.current.click()}
            >
              <input
                type="file"
                ref={fileInputRef}
                style={{ display: "none" }}
                accept=".pdf"
                onChange={handleFileChange}
              />

              {!file ? (
                <div className="upload_content">
                  <div className="pdf_icon_wrapper">
                    <img src={assets.ic_pdf_purple} alt="pdf" />
                  </div>
                  <p className="main_text">Drag and drop your PDF file here</p>
                  <p className="or_text">or</p>
                  <button className="browse_btn">Browse File</button>
                  <p className="disclaimer">
                    Only PDF files are allowed. Max file size: 20MB
                  </p>
                </div>
              ) : (
                <div className="upload_content">
                  <div className="pdf_icon_wrapper">
                    <img src={assets.ic_pdf_purple} alt="pdf" />
                  </div>
                  <p className="file_name">{file.name}</p>
                  {!uploadSuccess && (
                    <button
                      className="change_btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        fileInputRef.current.click();
                      }}
                    >
                      Click to change
                    </button>
                  )}
                </div>
              )}
            </div>
          </div>

          <div className="card_footer">
            {uploadSuccess && (
              <button
                className="upload_submit_btn kb_btn"
                disabled={isCallingKB}
                onClick={handleKnowledgeBaseAction}
              >
                <img src={assets.ic_knowledge} alt="knowledge" />
                {isCallingKB ? "Loading..." : "Add To Knowledge Base"}
              </button>
            )}
            <button
              className="upload_submit_btn"
              // disabled={
              //   !selectedChapter || !file || isUploading || uploadSuccess
              // }
              // disabled={
              //   !selectedChapter ||
              //   (selectedChapter === "All Chapters" && !customChapter.trim()) ||
              //   !file ||
              //   isUploading ||
              //   uploadSuccess
              // }
              disabled={
                !selectedChapter ||
                (selectedChapter?.toLowerCase().includes("all") &&
                  !customChapter.trim()) ||
                !file ||
                isUploading ||
                uploadSuccess
              }
              onClick={handleUpload}
            >
              <img src={assets.ic_upload} alt="upload" />
              {isUploading ? "Uploading..." : "Upload PDF"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
